import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ALL_TARIFF_RATES_QUERY } from "../../../../graphql/Tariffs/Tariffs.graphql";
import { TARIFF_RATE_COLUMNS } from "../columns";
import DataTable from "../../../../components/DataTable";

import { ModalContext } from "../../../../components/ModalProvider";
import { EditTariffRateForm } from "../../../../components/Tariffs";

const Rates = ({ id }) => {
  const { setModalOpen } = useContext(ModalContext);
  return (
    <DataTable
      columns={TARIFF_RATE_COLUMNS}
      dataQuery={ALL_TARIFF_RATES_QUERY}
      name="TariffRate"
      where={{ TariffRecIdRef: parseInt(id) }}
      onRowClick={tariffRate =>
        setModalOpen(
          true,
          <EditTariffRateForm
            tariffRate={tariffRate}
            onComplete={() => setModalOpen(false, "")}
          />
        )
      }
    />
  );
};

Rates.propTypes = {
  id: PropTypes.number.isRequired
};
export default Rates;
